import { AiFillHome } from "react-icons/ai";

export const SidebarData = [
  {
    title: "Home",
    path: "/coffeeroasters-site",
    icons: <AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "About Us",
    path: "/aboutus",
    icons: <AiFillHome />,
    cName: "nav-text",
  },
  {
    title: "Create Your Plan",
    path: "/createplan",
    icons: <AiFillHome />,
    cName: "nav-text",
  },
];
